import { combineReducers } from 'redux';
import contentFeatureAthletes from './feature-athletes-reducer';
import contentSuggestionsWidget from './suggestions-widget-reducer';

const featuredAthletesReducer = combineReducers({
  contentFeatureAthletes,
  contentSuggestionsWidget,
});

export default featuredAthletesReducer;
